<template>
  <div class="form-floating mb-3">
    <input
      :id="id"
      :name="name"
      :autocomplete="autocomplete"
      v-model="password"
      :type="inputType"
      class="form-control form-control-lg"
      required
    />
    <button
      type="button"
      class="password-toggle"
      @click="showPassword = !showPassword"
    >
      <i :class="showPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"></i>
    </button>
    <label :for="id">{{ placeholder }}</label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    autocomplete: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Contraseña',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showPassword: false,
    };
  },
  computed: {
    password: {
      set(newValue) {
        this.$emit('input', newValue);
      },
      get() {
        return this.value;
      },
    },
    inputType() {
      return this.showPassword ? 'text' : 'password';
    },
  },
};
</script>

<style scoped>
.password-toggle {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  z-index: 3;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #6c757d;
  transform: translateY(-50%);
}
</style>